<template>
    <div>
        <v-icon size="45">far fa-frown</v-icon>

        <h3 class="mt-2 font-weight-regular">¡Lo sentimos!, lo que buscas ya no está disponible.</h3>
        <v-flex xs12 mt-3>
            <v-btn
                    @click="$router.go(-1)"
                    dark
                    depressed
                    rounded
            >
                <v-icon class="mr-2">arrow_back</v-icon>
                Regresar
            </v-btn>
        </v-flex>
    </div>
</template>

<script>
    export default{

    }
</script>
